export default __webpack_public_path__ + "static/poster-273ef9636ad783c1f321a45f380511a4.png";